<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="添加照片"
      right-text="确定"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <div class="image-uploader">
        <van-uploader
          :after-read="afterRead"
          @delete="deleteImg"
          v-model="fileList"
          multiple
          :max-count="9"
        />
      </div>

      <div class="btn-area">
      <van-button @click="onClickRight()" class="mybtn" block
        >确定</van-button
      >
    </div>
    </div>
  </div>
</template>

<script>
 import { Toast } from "vant";
export default {
  data() {
    return {
      fileList: [
        // { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // { url: 'https://cloud-image', isImage: true },
      ],
      id : 0,
      input: {
        gid : "",
        Base64ContentList: []
      }
    };
  },
  components: {},
  mounted(){
       this.input.gid = this.$route.query.gid;
       this.id = this.$route.query.id;
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      console.log(this.input);
      var that=this;
      var postData=this.input;
      if(postData.Base64ContentList.length==0){
          Toast("至少提交一张照片！");
          return false;
      }
      Object.assign(postData,{
          type:"ImageImagesAddVue"
      });
      that.$store.dispatch(postData).then(res=>{
          //console.log(res);
          Toast(res.Message);
          if(res.IsSuccess)
          {
              this.$router.go(-1);
          }

      },error=>{

      });


    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var that = this;
      console.log(file);
      if (file.length != null && file.length > 0) {
        file.forEach(element => {
          that.input.Base64ContentList.push(element.content);
        });
      } else {
        that.input.Base64ContentList.push(file.content);
      }
    },
    deleteImg(file) {
      var that = this;
      that.input.Base64ContentList.splice(
        that.input.Base64ContentList.indexOf(file.content),
        1
      );
    }
  }
};
</script>

<style scoped>
</style>
